//@ts-ignore

import("./bootstrap");
